module.exports = "https://static.energy5.com/_next/static/images/drops-7bc259ff58132d6a7fb4965a00646026.png";